import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'components/base';

import { Picture, SectionHead, imageShape } from '../landing/shared';

// "Who are you shopping for": rings that jump to an anchor on the same page. Phones scroll
// them horizontally.
const RecipientList = ({ eyebrow, title, aside, recipients, track }) => (
  <section className="lnd-section gft-recipients">
    <Container>
      <SectionHead eyebrow={eyebrow} title={title} aside={aside} />
    </Container>
    <ul className="gft-recipient-list">
      {recipients.map((recipient, index) => (
        <li key={recipient.name} className={`gft-recipient gft-ring--${index % 3}`}>
          <a
            href={`#${recipient.target}`}
            className="gft-recipient-link"
            onClick={track('recipient', 'recipients', recipient.target)}
          >
            <span className="gft-ring">
              <Picture image={recipient.image} sizes="(min-width: 768px) 156px, 78px" alt="" />
            </span>
            <span className="gft-recipient-name">{recipient.name}</span>
            <span className="gft-recipient-hint">{recipient.hint}</span>
          </a>
        </li>
      ))}
    </ul>
  </section>
);

RecipientList.propTypes = {
  eyebrow: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  aside: PropTypes.node,
  recipients: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      hint: PropTypes.string.isRequired,
      // Element id the ring jumps to.
      target: PropTypes.string.isRequired,
      image: imageShape.isRequired,
    }),
  ).isRequired,
  track: PropTypes.func.isRequired,
};

export default RecipientList;
